import { render, staticRenderFns } from "./Bordereaux.vue?vue&type=template&id=8c66f202"
import script from "./Bordereaux.vue?vue&type=script&lang=js"
export * from "./Bordereaux.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Bordereaux.vue?vue&type=style&index=1&id=8c66f202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports